// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M6.9 3H12.5C13.6 3 14.5 3.9 14.5 5V11C14.5 12.1 13.6 13 12.5 13H6.9C6.35 13 5.87 12.79 5.46 12.43L1.64 9.04C1.02 8.49 1.02 7.51 1.64 6.96L5.46 3.57C5.87 3.21 6.35 3 6.9 3Z',
  'M7.5 6L11.5 10M11.5 6L7.5 10',
];
